import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

import { SnTag, SnLocation } from '@lib/api/entities';
import { snListStagger, snFadeOut, snFadeIn } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-location-table',
  templateUrl: './location-table.component.html',
  styleUrls: ['./location-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [snListStagger, snFadeIn, snFadeOut],
})
export class LocationTableComponent extends SnTableBaseComponent<SnLocation> {
  @Output()
  public readonly tagSelected = new EventEmitter<SnTag>();

  constructor() {
    super();
  }

  public trackBy(index: number, item: SnLocation): any {
    return item.id;
  }

  public onTagSelected(tag: SnTag): void {
    this.tagSelected.emit(tag);
  }
}
